import React, { useState } from 'react'
import { accessor, getOrderStatusType } from '../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import { OrderContextMenu } from './OrderContextMenu';
import { SelectWorkerPopup } from '../../components/SelectWorkerPopup';
import { deleteOrder, getDeps, resetOrder, revokeOrder } from '../../redux/orderSlice';
import { CreateOrderDep } from './CreateOrderDep';
import { Order } from './Order';
import { EditableOrder } from './EditableOrder';
import { FinishOrderPopup } from './FinishOrderPopup';
import { StaticPopup } from '../../components/StaticPopup';
import { deleteImage } from '../../redux/staticSlice';
import { OrderEventsPopup } from './OrderEventsPopup';

export const OrderContainer = ({titles, data, zoom, gridTemplateColumns, colorState}) => {

    const dispatch = useDispatch();
    const userInfo = useSelector((state) => state.auth);
    //      CONTEXT MENU SETS
    const disabledMenu = {opened: false, x: null, y: null};
    const [contextMenu, setContextMenu] = useState(disabledMenu);
    const closeMenuHandler = () => setContextMenu(disabledMenu);

    const contextMenuHandler = (evt) => {
        const { clientX: offsetLeft, clientY: offsetTop } = evt;
        const offsetRight = window.innerWidth - offsetLeft;
        const offsetBottom = window.innerHeight - offsetTop;

        const menuOffset = 10;

        const menuWidth = 200;
        const menuHeight = 300;

        const multiX = offsetRight < menuWidth ? -1 : 1;
        const multiY = offsetBottom < menuHeight ? -1 : 1;

        const menuXOffset = multiX > 0 ? menuOffset : -menuWidth - menuOffset;
        const menuYOffset = multiY > 0 ? menuOffset : -menuHeight - menuOffset;

        const rect = evt.currentTarget.parentElement.getBoundingClientRect();

        const offsetX = offsetLeft - rect.left + menuXOffset;
        const offsetY = offsetTop - rect.top + menuYOffset;

        setContextMenu({opened: true, x: offsetX, y: offsetY});
    }

    //  REVOKE ORDER BUT NO POPUP HAHA
    const revokeOrderHandler = () => {
        if (window.confirm('Вы пытаетесь отозвать заявку. Подтвердите действие')) {
            dispatch(revokeOrder(data._id));
            closeMenuHandler();
        }
    }

    const resetOrderHandler = () => {
        if (window.confirm('Вы пытаетесь сбросить результаты заявки. Подтвердите действие')) {
            dispatch(resetOrder(data._id));
            closeMenuHandler();
        }
    }

    const deleteOrderHandler = () => {
        if (window.confirm(`Вы действительно хотите безвозвратно удалить заявку ${data.id}?`)) {
            dispatch(deleteOrder(data._id));
            closeMenuHandler();
        }
    }

    //      ASSIGN ORDER WORKER POPUP
    const [workerPopup, setWorkerPopup] = useState(false);
    const openWorkersPopupHandler = () => {
        setWorkerPopup(true);
        closeMenuHandler();
    }

    //      CREATE ORDER DEP POPUP
    const depsPopupDefault = {opened: false, isWarranty: false};
    const [depsPopup, setDepsPopup] = useState(depsPopupDefault);
   
    const openDepsPopup = (isWarranty) => {
        setDepsPopup({opened: true, isWarranty});
        closeMenuHandler();
    }
    const closeDepsPopup = () => {
        setDepsPopup({opened: false, isWarranty: false});
    }

    //EDIT ORDER SWITCHER
    const [isEdit, setEdit] = useState(false);
    const editOrderHandler = (value) => {
        setEdit(value)
        closeMenuHandler();
    }

    //COMPLETE (FINISH) ORDER POPUP
    const [finishPopup, setFinishPopup] = useState(false);
    const openFinishPopupHandler = () => {
        setFinishPopup(true);
        closeMenuHandler();
    }

    const getDepsHandler = () => {
        closeMenuHandler();
        const warranties = data.details.warranties || [];
        const repeats = data.details.repeats || [];
        const deps = [...warranties, ...repeats];
        const root = data.details.root;
        if (root === null || deps.every(id => id !== root)) {
            deps.push(root || data._id);
        }
        dispatch(getDeps(deps))
    }

    const [eventsPopup, setEventsPopup] = useState(false);
    const getOrderEventsHandler = () => {
        setEventsPopup(true);
        closeMenuHandler();
    }

    const [imageType, setImageType] = useState(null);

    const setPhotoPopupHandler = (type) => {
        setImageType(type);
    }

    const menuActions = {
        openWorkerPopup: openWorkersPopupHandler,
        openDepPopup: openDepsPopup,
        getDeps: getDepsHandler,
        openFinishPopup: openFinishPopupHandler,
        setEditOrder: editOrderHandler,
        revokeOrder: revokeOrderHandler,
        getEvents: getOrderEventsHandler,
        resetOrder: resetOrderHandler,
        deleteOrder: deleteOrderHandler,
        setPhotoPopup: setPhotoPopupHandler,
    }

    const orderColorType = getOrderStatusType(data);
    const colorStyle = {background: colorState.find(c => c.type === orderColorType)?.color || 'transparent'}
    
    const isHandOver = !data.details.finished || data.details.isHandOver || data.handOver <= 0;
    const editCompleteDataAccess = accessor.editOrderCompleteData(userInfo);
    const deleteImageHandler = (type, fileName) => {
        dispatch(deleteImage({type, name: fileName}));
    }

    return (
        <div className={`order ${isEdit ? 'edit' : ''} ${!isHandOver ? 'not-handover' : ''}`}
        style={!isEdit ? {gridTemplateColumns} : {}} 
        onContextMenu={contextMenuHandler}>
            {isEdit ? 
            <EditableOrder gridTemplateColumns={gridTemplateColumns} data={data} titles={titles} closeEditor={() => setEdit(false)}/> : 
            <Order data={data} titles={titles} color={colorStyle} />}
            {imageType && <StaticPopup deleteAccess={editCompleteDataAccess} deleteFunc={deleteImageHandler} closeFn={() => setImageType(null)}
                content={imageType === 'bso' ? data.BSOPhotos.map(n => ({fileName: n, isPhoto: true, type: 'bso'})) : data.chequePhotos.map(n => ({fileName: n, isPhoto: true, type: 'cheque'}))}/>}
            {contextMenu.opened && 
            <OrderContextMenu
                actions={menuActions}
                close={closeMenuHandler}
                order={data}
                zoom={zoom}
                position={{x: contextMenu.x, y: contextMenu.y}}
            />}
            
            {workerPopup && <SelectWorkerPopup order={data} closeFn={() => setWorkerPopup(false)} />}
            {depsPopup.opened && <CreateOrderDep order={data} closeFn={closeDepsPopup} isWarranty={depsPopup.isWarranty} cityUTC={data.city.UTC}/>}
            {finishPopup && <FinishOrderPopup order={data} closeFn={() => setFinishPopup(false)}/>}
            {eventsPopup && <OrderEventsPopup order={data} closeFn={() => setEventsPopup(false)}/>}
            
        </div>
    )
}